module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.exciseEntry.index.title')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-row', {
    staticClass: "margin-b-10 margin-10 padding-t-20",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "ml-3",
    attrs: {
      "sm": 8
    }
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.dateRange.placeholder')) + ":\n                ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "Pick a month"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.filter.month),
      callback: function($$v) {
        _vm.$set(_vm.filter, "month", $$v)
      },
      expression: "filter.month"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "ml-3",
    attrs: {
      "sm": 8
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.exciseEntry",
      "hasLabel": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-b-10 margin-10",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24
    }
  }, [_c('v-excise-table', {
    attrs: {
      "list": _vm.entries,
      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
      "translation": "static.exciseEntry.table",
      "loading": _vm.loading,
      "update_list": _vm.updateList,
      "link": _vm.openLink
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb34d38","hasScoped":true}!./src/app/pages/withNavigation/exciseEntry/index/index.html
// module id = 3056
// module chunks = 1